import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { composeCurrentPerson } from '@/domain/identity/canonicalIdentity';
import { useBusinessProfileIdentitySource } from './useBusinessProfileIdentitySource';

export const useCurrentPerson = () => {
  const { user, profile, loading: authLoading } = useAuth();
  const businessProfileQuery = useBusinessProfileIdentitySource(user?.id);

  const person = useMemo(
    () =>
      composeCurrentPerson({
        userId: user?.id,
        profile: profile
          ? {
              email: profile.email,
              firstName: profile.first_name,
              lastName: profile.last_name,
              phone: profile.phone,
              department: profile.department,
            }
          : null,
        authentication: user
          ? {
              email: user.email,
              firstName: user.user_metadata?.first_name || user.user_metadata?.given_name,
              lastName: user.user_metadata?.last_name || user.user_metadata?.family_name,
              phone: user.phone || user.user_metadata?.phone,
            }
          : null,
        businessProfile: businessProfileQuery.data
          ? {
              contactPerson: businessProfileQuery.data.contact_person,
              email: businessProfileQuery.data.email,
              phone: businessProfileQuery.data.phone,
            }
          : null,
      }),
    [businessProfileQuery.data, profile, user],
  );

  return {
    person,
    isAuthenticated: Boolean(user),
    isLoading: authLoading || (Boolean(user) && businessProfileQuery.isLoading),
    error: businessProfileQuery.error,
  };
};
